import { Link } from 'react-router-dom';
import './Footer.css';

const socialLinks = [
  { href: 'https://www.facebook.com/codeedextechnologies?mibextid=LQQJ4d', icon: 'fa-brands fa-facebook-f', label: 'Facebook' },
  { href: 'https://www.instagram.com/codeedextechnologies/?hl=en', icon: 'fa-brands fa-instagram', label: 'Instagram' },
  { href: 'https://www.linkedin.com/in/codeedex-technologies-3899b92b6/', icon: 'fa-brands fa-linkedin-in', label: 'LinkedIn' },
  { href: 'https://www.youtube.com/@CodeedexTechnologies/featured', icon: 'fa-brands fa-youtube', label: 'YouTube' },
];

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Projects', path: '/portfolio' },
  { label: 'Internships', path: '/intern' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contactus' },
];

const legalLinks = [
  { label: 'Terms & Conditions', path: '/terms' },
  { label: 'Cancellation / Refund Policy', path: '/cancel' },
];

const Footer = () => {
  const handleCall = () => {
    window.location.href = 'tel:+919778564277';
  };

  return (
    <footer className="site-footer">
      <div className="footer-glow" />

      <div className="footer-inner">
        {/* Brand column */}
        <div className="footer-col footer-brand">
          <img
            src="https://i.postimg.cc/7L5WS7qQ/Screenshot-2024-05-06-125647-removebg-preview.png"
            alt="Codeedex"
            className="footer-logo"
          />
          <p className="footer-tagline">
            Unlocking the digital realm with excellence — Codeedex pioneers innovation and simplicity.
          </p>
          <div className="footer-socials">
            {socialLinks.map(({ href, icon, label }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} className="social-btn">
                <i className={icon} />
              </a>
            ))}
          </div>
        </div>

        {/* Quick links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-list">
            {quickLinks.map(({ label, path }) => (
              <li key={path}>
                <Link to={path} className="footer-link">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-col">
          <h4 className="footer-heading">Legal</h4>
          <ul className="footer-list">
            {legalLinks.map(({ label, path }) => (
              <li key={path}>
                <Link to={path} className="footer-link">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-contact-list">
            <li>
              <i className="fa fa-map-marker-alt" />
              <Link to="https://maps.app.goo.gl/PHTPkrzkYEHsTjCfA" target="_blank" rel="noreferrer" className="footer-link">
                3rd Floor, KMK Arcade,<br />Perinthalmanna, Calicut RD,<br />679322
              </Link>
            </li>
            <li>
              <i className="fa fa-phone" />
              <button onClick={handleCall} className="footer-link footer-phone">
                +91 97785 64277
              </button>
            </li>
            <li>
              <i className="fa fa-envelope" />
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=info@codeedextechnologies.com"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                info@codeedextechnologies.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Codeedex Technologies. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
